import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useSelector } from 'react-redux';
import { Box, Grid, Typography } from '@mui/material';

const ViewSelectedResultsButton = () => {
  const history = useHistory();
  const [error, setError] = useState('');

  const { selectedCatalogOptions } = useSelector(state => state.reports);

  const showResultsHandler = () => {
    const { selectedRefs, currencies } = selectedCatalogOptions.reduce(
      (acc, { catalogRef, catalogCurrencyCode }) => {
        const refStr = acc.selectedRefs;
        acc.selectedRefs = refStr ? `${refStr},${catalogRef}` : catalogRef;
        acc.currencies.add(catalogCurrencyCode);
        return acc;
      },
      { selectedRefs: '', currencies: new Set() }
    );
    if (currencies.size > 1) setError('Please select sessions with the same currency.');
    else {
      history.push({
        pathname: '/reports/sessionResults/viewSessionResults',
        state: { selectedRefs }
      });
    }
  };

  return (
    <>
      <Grid container justifyContent="space-between" sx={{ mb: 2 }}>
        <Box className="mt-4 ml-3 mr-4 font-italic">
          ** Scroll in table to see more sales
        </Box>
        <Button
          color="primary"
          className="cursor-not-allowed placeBidbutton"
          disabled={!selectedCatalogOptions.length}
          onClick={showResultsHandler}
        >
          <span>
            View Selected{' '}
            {selectedCatalogOptions.length ? `(${selectedCatalogOptions.length})` : ''}
          </span>
        </Button>
      </Grid>
      {error && (
        <Grid container justifyContent="flex-end" sx={{ mb: 2 }}>
          <Typography variant="body2" color="red">
            {error}
          </Typography>
        </Grid>
      )}
    </>
  );
};

export default ViewSelectedResultsButton;
